export const FieldRow: React.FC<{
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
}> = ({ icon, label, value }) => (
  <div className="flex items-start gap-2.5 py-2.5 border-b border-gray-100/20 last:border-0 last:pb-0 first:pt-0">
    <div className="w-7 h-7 md:w-8 md:h-8 rounded-md bg-primary-50/20 border border-primary-100/20 flex items-center justify-center flex-shrink-0 mt-0.5 text-primary-400">
      {icon}
    </div>
    <div className="min-w-0 w-full">
      <p className="text-xs md:text-sm text-gray-400 mb-0.5">{label}</p>
      <div className="text-[13px] font-medium text-black">{value}</div>
    </div>
  </div>
);
